import * as plugins from "./plugins.js";
import * as woocommerce from "./woocommerce.js";
import * as popup from "./popup.js";
import * as tracking from "./tracking.js";
import * as chat from "./chat.js";

jQuery(window).on("load", function () {
  plugins.init();

  woocommerce.init();

  tracking.init_gtmtracking();

  popup.init();

  chat.init();
});
